import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { ShareDocumentDialog } from "../../-components/share-document-dialog"

export const Route = createFileRoute(
  "/_layout/documents/_list/share/$documentId",
)({
  component: ShareDocumentModal,
})

function ShareDocumentModal(): React.ReactElement {
  const { documentId } = Route.useParams()
  const navigate = useNavigate()

  return (
    <ShareDocumentDialog
      documentIds={[documentId]}
      onClose={() => navigate({ to: "/documents", search: true })}
    />
  )
}
